<template>
  <div class="gridClass my-8 font-bold mt-5">
    <div class="flex items-center justify-center lg:justify-start">
      <IconTriangle v-if="important" class="me-1 fill-blue-500" />
      <span class="text-xl">{{ data.title }}</span>
      <span>{{ data.subtitle }}</span>
    </div>
    <div class="">
      <div v-if="data.desc" class="font-semibold text-justify my-4">{{ data.desc }}</div>
      <ul class="flex flex-col list-inside" :class="listNone ? '' : 'list-disc ms-7'" >
      <li v-for="item in data.features" :key="item.id" class="text-start mt-1">
        <span class="font-medium">{{ item.text }}</span>
      </li>
    </ul>
    </div>
    
  </div>
</template>

<script setup>
  defineProps ({
    data: Object,
    important: Boolean,
    listNone: Boolean
  })
</script>
